// src/components/Admin/ExcluirLink.jsx
import React, { useState } from 'react';
import { collection, getDocs, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useNavigate } from 'react-router-dom';
import Notification from '../Notification';

const ExcluirLink = () => {
  const navigate = useNavigate();
  const [key, setKey] = useState('');
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false); // Estado para controlar a visibilidade

  const handleFetchLink = async () => {
    if (!key) return; // Não faz nada se o campo Key estiver vazio
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, 'links'));
      const link = querySnapshot.docs.find((doc) => doc.data().key === key);
      if (link) {
        setShowConfirmation(true); // Mostra a confirmação de exclusão
      } else {
        setNotification({
          message: 'Link não encontrado!',
          type: 'error',
        });
      }
    } catch (error) {
      setNotification({
        message: 'Erro ao buscar link: ' + error.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteLink = async () => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, 'links'));
      const link = querySnapshot.docs.find((doc) => doc.data().key === key);
      if (link) {
        const docRef = doc(db, 'links', link.id); // Cria uma referência ao documento
        await deleteDoc(docRef); // Exclui o documento
        setNotification({
          message: 'Link excluído com sucesso!',
          type: 'success',
        });
        setTimeout(() => {
          navigate('/admin/dashboard');
        }, 2000);
      } else {
        setNotification({
          message: 'Link não encontrado!',
          type: 'error',
        });
      }
    } catch (error) {
      setNotification({
        message: 'Erro ao excluir link: ' + error.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Formulário inicial (campo Key) */}
      {!showConfirmation && (
        <div className="admin-form">
          <h2>Excluir Link</h2>
          <div className="form-group">
            <label htmlFor="key">ID</label>
            <input
              type="text"
              id="key"
              placeholder="Digite o ID"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              required
            />
            <button
              type="button"
              className="fetch-button"
              onClick={handleFetchLink}
              disabled={loading}
            >
              {loading ? 'Buscando...' : 'Buscar Link'}
            </button>
          </div>
        </div>
      )}

      {/* Confirmação de exclusão */}
      {showConfirmation && (
        <div className="admin-form">
          <h2>Confirmar Exclusão</h2>
          <p>Tem certeza que deseja excluir este link?</p>
          <div className="form-actions">
            <button
              type="button"
              className="submit-button"
              onClick={handleDeleteLink}
              disabled={loading}
            >
              {loading ? 'Excluindo...' : 'Confirmar Exclusão'}
            </button>
            <button
              type="button"
              className="cancel-button"
              onClick={() => setShowConfirmation(false)} // Volta ao formulário inicial
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* Exibe a notificação se existir */}
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
    </>
  );
};

export default ExcluirLink;